import { extract } from "./../../../ricos-content/lib/extract";
import { Node_Type } from "./../../../ricos-schema/legacy/wix/rich_content/v1";
function convertDataToGalleryItems(type, data) {
  switch (type) {
    case Node_Type.IMAGE:
      return data.image?.src && !data?.disableExpand ? [{ image: { media: { ...data.image } }, disableDownload: data.disableDownload }] : [];
    case Node_Type.GALLERY: {
      return data?.disableExpand ? [] : data.items.map((item) => {
        return { ...item, disableDownload: data.disableDownload };
      });
    }
    default:
      return [];
  }
}
function getImagesData(content) {
  const imagesData = {
    images: [],
    imageMap: {}
  };
  let index = 0;
  return extract(content.nodes).filter((node) => [Node_Type.IMAGE, Node_Type.GALLERY].includes(node.type)).map((node) => ({
    data: node[`${node.type.toLowerCase()}Data`],
    type: node.type,
    id: node.id
  })).get().reduce((items, { data, type, id }) => {
    const { images, imageMap } = items;
    const galleryItems = convertDataToGalleryItems(type, data);
    const currentIndex = index;
    index += galleryItems.length;
    return {
      images: [...images, ...galleryItems],
      imageMap: {
        ...imageMap,
        [id]: currentIndex
      }
    };
  }, imagesData);
}
export {
  getImagesData
};
//# sourceMappingURL=getImagesData.js.map
